import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {LonerStatics} from "../../LonerStatics";
import {Loner} from "../../Loner";
import {LonerSymbol} from "../../reels/symbols/main/LonerSymbol";
import {LonerSymbolStates} from "../../../core/reel/ReelInterfaces";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {LonerWinLineContainer} from "../../components/LonerWinLineContainer";
import {LonerSound} from "../../sound/LonerSound";
import {LonerIndividualSymWinView} from "./LonerIndividualSymWinView";
import {LonerGameMode} from "../../server/LonerGameMode";

/**
 * Created by Jerker Nord on 2022-11-23.
 */

export class LonerInitialWinView extends PIXI.Container implements StageLayer {
    private _individualSymWinWaysCont: PIXI.Container;
    private _bigWinHighLightLastSoundPlayed: number = 0;
    private _winContainers: LonerWinLineContainer[];
    private _allWinTL: gsap.core.Timeline;

    constructor() {
        super();
        this.name = "LonerInitialWinView";
        this.position = LonerStatics.MAIN_REELS_VIEW_POSITION;
        this.init();
    }

    public getInitialWinAnimation(): gsap.core.Timeline {
        Loner.individualWin.shouldRun = true;
        this._allWinTL = gsap.timeline();
        this._winContainers = [];

        const wins: boolean[][] = Loner.model.allWinSymPositions,
            winHighlightSound:string=LonerSound.WIN_HIGHLIGHT.next(),
            darkDownTLs: gsap.core.Timeline[] = [];

        let symbol: LonerSymbol;

        // individual symbol win highlight
        if (Loner.model.betWayWins.length > 0) {
            const addingTL: gsap.core.Timeline = gsap.timeline(),
                highLightDur:number=LonerStatics.WIN_HIGHLIGHT_ANIM_DURATION;
            addingTL.add(()=>{
                Loner.symOverlayAnimationsView.visible=true;
                this.visible=true;
            })
            for (let betWayIdx = 0; betWayIdx < Loner.model.betWayWins.length; betWayIdx++) {
                const reelWinPositions: boolean[][] = Loner.model.betWayWins[betWayIdx].reelWinPositions,
                    symPosForWinWays:[number,number]=[0,0],
                    individualSymWinTL:gsap.core.Timeline=gsap.timeline();
                for(let reelIdx:number=0;reelIdx<reelWinPositions.length;reelIdx++){
                    for(let symIdx:number=0;symIdx<reelWinPositions[reelIdx].length;symIdx++){
                        if(reelWinPositions[reelIdx][symIdx]){
                            symPosForWinWays[0]=reelIdx;
                            symPosForWinWays[1]=symIdx;
                            individualSymWinTL.add(Loner.symOverlayAnimationsView.playWinHighlightAnim(reelIdx,symIdx,Loner.model.evaluatedArea[reelIdx][symIdx],highLightDur),0);
                        }
                    }
                }
                const winWaysObj:LonerIndividualSymWinView=new LonerIndividualSymWinView(Loner.model.betWayWins[betWayIdx].multipliedAmount,Loner.model.betWayWins[betWayIdx].numberOfCombinations,new PIXI.Point(144*symPosForWinWays[0],Loner.allReelView.mainReelModels[symPosForWinWays[0]].reelView.symbols[symPosForWinWays[1]+2].position.y));
                this._individualSymWinWaysCont.addChild(winWaysObj);
                individualSymWinTL.add([winWaysObj.showWinAndWays(highLightDur),()=>{
                    Loner.soundPlayer.playSound(winHighlightSound);
                }],0);
                addingTL.add(individualSymWinTL);
            }
            addingTL.add(()=>{
                Loner.symOverlayAnimationsView.visible=false;
                this.visible=false;
            });
            this._allWinTL.add(addingTL);
        }


        // win highlight of all winning symbols
        if (Loner.model.winRatio >= 15) {
            const winHighlightAllSymTL: gsap.core.Timeline = gsap.timeline();
            winHighlightAllSymTL.add(() => {
                Loner.symOverlayAnimationsView.visible = true;
            });
            for (let reelIdx: number = 0; reelIdx < Loner.model.allWinSymPositions.length; reelIdx++) {
                for (let symIdx: number = 0; symIdx < Loner.model.allWinSymPositions[reelIdx].length; symIdx++) {
                    if (Loner.model.allWinSymPositions[reelIdx][symIdx]) {
                        winHighlightAllSymTL.add(Loner.symOverlayAnimationsView.playWinHighlightAnim(reelIdx, symIdx, Loner.model.evaluatedArea[reelIdx][symIdx]), 0);
                    }
                }
            }
            winHighlightAllSymTL.add(() => {
                let randomNumber: number = 0;
                while (this._bigWinHighLightLastSoundPlayed === randomNumber) {
                    randomNumber = MathHelper.randomIntInRange(0, 2);
                }
                this._bigWinHighLightLastSoundPlayed = randomNumber;
                Loner.soundPlayer.playSound(LonerSound.BIG_WIN_HIGHLIGHT[this._bigWinHighLightLastSoundPlayed]);
            }, 0);
            winHighlightAllSymTL.add(() => {
                Loner.symOverlayAnimationsView.visible = false;
            });
            this._allWinTL.add(winHighlightAllSymTL);
        }

        // Dark down all no-win syms
        for (let i: number = 0; i < wins.length; i++) {
            for (let j: number = 0; j < wins[i].length; j++) {
                const tl: gsap.core.Timeline = gsap.timeline();
                if (!wins[i][j]) {
                    symbol = (Loner.allReelView.mainReelModels[i].reelView.symbols[j + 3] as LonerSymbol);
                    if (symbol.bigSymbolPart == false) {
                        tl.add(symbol.getNewStateAnimation(LonerSymbolStates.NO_WIN, 0.1));
                    }
                }
                darkDownTLs.push(tl);
            }
        }

        let allInitWins: gsap.core.Timeline[][] = [];
        let bigSymbolAdded: boolean = false;
        this._allWinTL.add([()=>{
            for (let i: number = 0; i < Loner.model.betWayWins.length; i++) {
                const winTLs: gsap.core.Timeline[] = [];
                //console.log("Win combo no: " + i);
                let winContainer: LonerWinLineContainer = Loner.winLineTopView.getContainer();
                this._winContainers.push(winContainer);
                //Check all reels for win syms in this symbol win
                for (let j: number = 0; j < 5; j++) {
                    if (Loner.model.betWayWins[i].reelWinPositions[j].includes(true)) {
                        for (let k: number = 0; k < Loner.model.betWayWins[i].reelWinPositions[j].length; k++) {
                            let symbol: LonerSymbol = (<LonerSymbol>Loner.allReelView.mainReelModels[j].reelView.symbols[k + 3]);
                            if (Loner.model.betWayWins[i].reelWinPositions[j][k] == true) {
                                if (symbol.bigSymbolPart == false) {
                                    //console.log("Win to sym: " + symbol.symbolName + " reel: " + symbol.reelId + " row: " + symbol.reelPosition);
                                    winContainer.winComboSymbols.push(symbol);
                                    winTLs.push(symbol.getInitialWinAnimation(winContainer));
                                } else {
                                    if (bigSymbolAdded == false) {
                                        bigSymbolAdded = true;
                                        winTLs.push(Loner.wildSymbolPool.getActivePresentationBigWild().getInitialWinAnimation(winContainer));
                                    }
                                }
                            }
                        }
                    }
                }
                allInitWins.push(winTLs);

                let nextReelWins: boolean[] = [];
                let currentReelWins: boolean[] = [];
                //j = reels
                //k = position
                for (let j: number = 0; j < 5; j++) {
                    if (Loner.model.betWayWins[i].reelWinPositions[j].includes(true)) {
                        //Get all wins on next reel
                        nextReelWins = [];
                        if (j < 4) {
                            for (let l: number = 0; l < Loner.model.betWayWins[i].reelWinPositions[j + 1].length; l++) {
                                nextReelWins.push(Loner.model.betWayWins[i].reelWinPositions[j + 1][l]);
                            }
                        }
                        currentReelWins = [false, false, false];
                    }
                }
            }
        },...darkDownTLs]);
        return this._allWinTL;
    }

    public resetWinContainers(): void {
        if (this._allWinTL && this._allWinTL.isActive()) {
            this._allWinTL.pause();
            this._allWinTL.kill();
        }
        this._individualSymWinWaysCont.removeChildren();
        for (let i: number = 0; i < Loner.initialWinView.winContainers.length; i++) {
            Loner.initialWinView.winContainers[i].reset();
        }
    }

    private init(): void {
        this._winContainers = [];
        this.visible = false;
        this._individualSymWinWaysCont = new PIXI.Container();
        this.addChild(this._individualSymWinWaysCont);
    }

    get winContainers(): LonerWinLineContainer[] {
        return this._winContainers;
    }
}